export default "__VITE_ASSET__NwBzczDS__"